// extracted by mini-css-extract-plugin
export default {"container":"Artist_container__Eb1PR","bg":"Artist_bg__Q0aer","content":"Artist_content__EYzmN"};